
import { defineComponent, ref } from '@nuxtjs/composition-api'
import { setupTranslationPrefixer } from '@/assets/util'
import { setupGtmCdpAction } from '@/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    title: { type: String, required: false, default: undefined },
    introduction: { type: String, required: false, default: undefined },
    body: { type: String, required: false, default: undefined },
    organizer: { type: String, required: false, default: undefined },
    genres: { type: Array, required: false, default: () => [] },
    partOfSeries: { type: Array, required: false, default: () => [] },
    theme: { type: String, required: false, default: undefined },
    sponsors: { type: Array, required: false, default: () => [] },
    audioWorks: { type: Array, required: false, default: () => [] },
    headerAudioIsPlaying: { type: Boolean, required: true },
    toggleHeaderAudio: { type: Function, required: true },
  },
  setup({ audioWorks }) {
    const audioWork =
      audioWorks
        ?.slice()
        .reverse()
        .find(({ audio }) => audio?.url) || {}
    const readMoreAboutConcert = ref(false)
    const gtmCdpAction = setupGtmCdpAction()

    function toggleReadMoreAboutConcert() {
      readMoreAboutConcert.value = !readMoreAboutConcert.value

      if (readMoreAboutConcert.value) {
        gtmCdpAction('CV07 - About concert read more clicked')
      }
    }

    return {
      ...setupTranslationPrefixer('event-detail'),
      audioWork,
      readMoreAboutConcert,
      toggleReadMoreAboutConcert,
    }
  },
})
